import { ACLs } from 'domain/constants';

export const getAclArray = () => {
  const output = [];
  Object.keys(ACLs).forEach((key) => {
    output.push({
      label: ACLs[key],
      value: key,
    });
  });
  return output;
};
